export const DEFAULTS = {
  config: {},
};
